<template>
  <div id="adminSelenaViews">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item">{{ setting }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url">Richieste form builder</router-link>
      </li>
    </ol>
      <div class="container-fluid card-title-admin">
        <h1>Richieste form builder</h1>
    </div>
     <div class="container-fluid">
      <!--div class="card">
        <div class="tab-content noborder">
          <div class="card-body">
            
          </div>
        </div>
      </!--div>-->
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabTable" role="tabpanel">
            <div class="card-body">
              <bootstrapTable
                :configurations="tableConfiguration"
                :datas="tableData"
                id="tableContents"
                ref="tableContents"
                :onCheck="onTableCheckCustomer"
                :results="tableNationResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabNationDetail" role="tabpanel">
            <div class="card-body" style="padding: 30px;">
              <div class="row">
                <div v-if="rowIdSelected > 0">
                  <h1 style="margin-top: 10px; font-size: 30px;font-weight: lighter;color: #303C54;">Dettaglio</h1>
                </div>
                <!-- dettaglio richiesta form builer --> 
                <div v-if="detailNationData.length > 0" style="width:100%;" id="detail-form-builder">
                  <div class="row" style="margin-bottom:5px;" v-for="detailNationDatas in detailNationData" v-bind:key="detailNationDatas.id">
                    <div class="col-6 align-self-center" >
                      <label>{{detailNationDatas.field}}</label>
                    </div>
                    <div class="col-6 align-self-center">
                      <label>{{detailNationDatas.value}}</label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12 text-right">
                  <button
                    type="button"
                    class="btn btn-danger"
                    data-dismiss="modal"
                    @click="cancelNewNation"
                  ><i class="fa fa-times"></i>&nbsp;Indietro</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import PageDetail from "@/components/PageDetail.vue";
export default {
  name: "adminSelenaViews",
  components: {
    BootstrapTable,
    PageDetail
  },
  data: function() {
    return {
      add: dictionaryHelpers.getDictionary("Add"),
      admin: dictionaryHelpers.getDictionary("Admin"),
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      save: dictionaryHelpers.getDictionary("Save"),
      setting: dictionaryHelpers.getDictionary("Setting"),
      language: dictionaryHelpers.getDictionary("Language"),
      updateCompleted: dictionaryHelpers.getDictionary('UpdateCompleted'),
      insertCompleted: dictionaryHelpers.getDictionary('InsertCompleted'),
      defaultLanguageOptions: [],
      detailNationConfiguration: [],
      tableNationResult: [],
      detailNationData: [],
      tableConfiguration: [],
      rowIdSelected:0,
      pageValueSelected: {
        id: 0,
        languagePageSetting: { content: null }
      },
      tableData: [],
      disableButton: true,
      url: window.location.pathname
    };
  },
  created() {
    var adminSelenaViews = this;

    spinnerHelpers.show();
    adminSelenaViews.defaultLanguageOptions = {
      id: storageData.sIdLanguage(),
      text: storageData.sDescriptionLanguage()
    };

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function(result) {
      adminSelenaViews.tableConfiguration = result.data.tablesConfigurations;
      adminSelenaViews.loadTable();
    });
  },
  methods: {
    loadTable(ln) {
      var adminSelenaViews = this;
      if(!functionHelpers.isValued(ln)){
        ln = storageData.sIdLanguage();
      }
      
      formBuilderServices.getAllRequest(function(result) {
        adminSelenaViews.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    onTableCheckCustomer() {
      var countRowSelected = this.$refs.tableContents.countRowSelected();
      if (countRowSelected == 0) {
        this.disableButton = true;
      } else {
        this.disableButton = false;
      }
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminSelenaViews = this;
      adminSelenaViews.loadTable(value);
      spinnerHelpers.hide();

    },
    RequestContactFormBuilderFormatter(value, row, index, field) {
      var adminSelenaViews = this;
      var html = "";
      '<div class="container-fluid" style="min-width:80px;"><div class="row">';
      html +=
         '<button class="btn btn-success" onclick="adminSelenaViews.__vue__.viewDatailInfo(' +
        row.id +
        ')"><i class="fa fa-pencil" title="' +
        this.openDetail +
        '" /></button>';
          html +=
         '<button class="btn btn-danger" onclick="adminSelenaViews.__vue__.delete(' + row.id + ',' + row.form_builder_id + ')"><i class="fa fa-trash"/></button>';
      return html;
    },

    viewDatailInfo(id){
      spinnerHelpers.show();
      var adminSelenaViews = this;
      this.rowIdSelected = id;

      $.each(this.tableData, function(i, row) {
        if (adminSelenaViews.rowIdSelected == row.id) {
          adminSelenaViews.detailNationData = row.listField;
        }
      });

      $("#tabTable").removeClass("active");
      $("#tabNationDetail").addClass("active");
      spinnerHelpers.hide();

    },
    delete(id, idForm) {
      if(confirm("Vuoi eliminare la richiesta?")){
        var adminSelenaViews = this;
        spinnerHelpers.show();
        formBuilderServices.delByContactAndFormId(id, idForm, function() {
          notificationHelpers.success(dictionaryHelpers.getDictionary("DeleteCompleted"));
          var ln = adminSelenaViews.pageValueSelected.languagePageSetting.idLanguage;
          if (!functionHelpers.isValued(ln)) {
            ln = storageData.sIdLanguage();
          }
          adminSelenaViews.loadTable(ln);
          window.scrollTo(0, 0);
        });
      }
    },
    onClickNew() {
      
    },
    cancelNewNation(){
      spinnerHelpers.show();
      this.detailNationData = [];
      $("#tabTable").addClass("active");
      $("#tabNationDetail").removeClass("active");
      spinnerHelpers.hide();
    },
    saveNewNation(){
     
    }
  }
};
</script>
<style>

.card-title-admin h1{
  font-size:40px;
  font-weight: lighter;
  color:#303C54;
}
.align-btn {
  position: absolute;
  margin-top: 30px;
  margin-left: 5px;
  z-index: 1;
}
#detail-form-builder{
  padding:15px;
}
#detail-form-builder .col-6 {
  padding-bottom:5px;
  padding-top:5px;
}
#detail-form-builder label {
  margin-bottom:0px;
  font-size:15px;
}
#detail-form-builder .row:nth-child(even){
  background: #ffffff;
}
#detail-form-builder .row:nth-child(odd){
  background: #E4E5E6;
}





</style>
